import styled from "@emotion/styled";

export const StyledConversationsWidget = styled.div`
  position: fixed;
  bottom: 70px;
  overflow: hidden;
  right: -10px;
  transition: all 0.3s ease;

  &.open {
    box-shadow:
      0 4px 12px rgba(0, 0, 0, 0.1),
      0 12px 32px rgba(0, 0, 0, 0.16);
    right: 10px;
    border-radius: 10px;
    bottom: 10px;
    background: white;
    height: 85dvh;
    .message-btn {
      display: none;
    }
    .widget-body {
      width: 450px;
    }
    .chat-container {
      max-height: calc(85dvh - 162px);
    }
    .down-icon {
      font-size: 20px;
      margin-left: 8px;
    }
  }

  .message-btn {
    font-size: 20px;
    height: 48px !important;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 52px;
    padding: 0 !important;
  }

  .message-btn .btn-text {
    opacity: 0;
    width: 0;
    white-space: nowrap;
    transition: all 0.3s ease;
  }

  .message-btn:hover {
    width: 200px;
    padding-inline: 18px !important;
  }

  .message-btn:hover .btn-text {
    opacity: 1;
    width: auto;
    margin-left: 8px;
  }
`;
